import { render, staticRenderFns } from "./PlateModal.vue?vue&type=template&id=3d111958&"
import script from "./PlateModal.vue?vue&type=script&lang=js&"
export * from "./PlateModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports